import RailTicketRestrictionsModalModule from './rail-ticket-restrictions-modal/rail-ticket-restrictions-modal-module';
import EuRailFareConditionsModalModule from './eurail-fare-conditions-modal/eurail-fare-conditions-modal-module';
import EuRailRailcardsModalModule from './eurail-railcards-modal/eurail-railcards-modal-module';

import RailHeaderController from './controllers/ukrailHeaderCtrl';
import RailListController from './controllers/ukrailListCtrl';
import RailOneWayController from './controllers/ukrailOnewayCtrl';
import RailRoundtripController from './controllers/ukrailRoundtripCtrl';
import RailSearchFormController from './controllers/ukrailSearchFormCtrl';
import RailTypeHeadController from './controllers/ukrailTypeaheadCtrl';
import RailAmendmentService from './rail-amendment/rail-amendment-service';
import RailsService from './services/rails-service';
import './controllers/modal-ukrail-add-to-basket.scss';

import RailRoutes from './ukrail-routes';

const MODULE_NAME = 'App.Ukrail';
const module = angular
    .module(MODULE_NAME, [
        'app',
        RailTicketRestrictionsModalModule,
        EuRailFareConditionsModalModule,
        EuRailRailcardsModalModule,
    ])
    .service('railAmendmentService', RailAmendmentService)
    .controller('UkrailHeaderController', RailHeaderController)
    .controller('UkrailListController', RailListController)
    .controller('UkrailOnewayController', RailOneWayController)
    .controller('UkrailRoundtripController', RailRoundtripController)
    .controller('UkrailSearchFormController', RailSearchFormController)
    .controller('UkrailTypeaheadController', RailTypeHeadController)
    .service('railsService', RailsService)
    .config(RailRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/ukrail-module.js